<template>
    <table class="table efsa">
        <colgroup>
            <col width="15%">
            <col width="15%">
            <col width="40%">
            <col width="30%">
        </colgroup>
        <thead>
        <tr>
            <th>Reference</th>
            <th>
                <div>Species</div>
                <div>Strain</div>
                <div>Dose regime</div>
                <div>Study type</div>
                <div>Route admin</div>
            </th>
            <th>
                <div>Parameters measured and measures of effects</div>
            </th>
            <th>
                <div>Overall outcome of the study</div>
            </th>
        </tr>
        </thead>
        <transition-group name="record-list" tag="tbody" class="record-list">
            <tr v-for="record of active_records" :key="record.refid" class="record">
                <td>
                    <div class="refid">#{{ record.refid }}</div>
                    <div><strong>{{ record.author }} <span
                            v-if="record.year">({{ record.year }})</span></strong></div>
                    <div>{{ record.title }}</div>
                </td>
                <td>
                    <div v-for="(ss_rec, index) of record.data.species_strain" :key="index">
                        <div v-for="(part, index) of ss_rec" :key="index">{{ part }}</div>
                    </div>
                    <br>
                    <data-list :data="record.data.bpa_st_ch_a_st_typ" :highlight="active_study_type"/>
                    <br>
                    <data-list :data="record.data.bpa_st_ch_a_rout_admin"/>
                </td>
                <td>
                    <div><strong>
                        <data-list :data="record.data.bpa_st_res_a_outc"/>
                    </strong></div>
                    <div v-for="(endp, index) of record.data.bpa_st_res_a_endp_" :key="index" :class="{'yellow': active_endpoint === endp.join(' / ')}">
                        {{ endp.join(" / ") }}
                    </div>
                </td>
                <td>
                    <data-list :data="record.data.bpa_st_ch_a_outc_overall"/>
                </td>

            </tr>
        </transition-group>

    </table>
</template>
<script>
  import DataList from './DataList'

  export default {
    name: 'AnimalTable',
    components: {DataList},
    props: {
      active_records: {},
      active_endpoint: null,
      active_study_type: null
    }
  }
</script>
<style lang="scss">

    table.efsa {
        border-collapse: collapse;

        thead {
            background-color: #f0f0f0;
            border: none;
            th {
                text-align: left;
                border: none;
                padding: 0.75rem;
            }
        }
        td {
            border-top: solid 1px #dddddd;
            padding: 0.75rem;
            //border-right: solid 1px #f0f0f0;
            position: relative;
            &:first-of-type {
                padding-top: 1.75rem;
            }
        }
        div.refid {
            font-size: 1.0rem;
            font-weight: bold;
            color: #e0e0e0;
            position: absolute;
            top: 0.25rem;
            left: 0.75rem;
        }
        tr:hover {
            div.refid {
                color: #999999;
            }
            td {
                background-color: #f5f5f5;
            }
        }
        div.yellow {
            background-color: yellow;
        }
    }

</style>
